<template>
    <div class="sales-filters">
        <v-row class="justify-md-start justify-center">
            <v-col cols="12" sm="6">
                <div style="max-width:300px">
                    <v-autocomplete
                        v-model="activeFilters.buyer"
                        clearable
                        :label="$t('buyer')"
                        :items="buyers"
                        :loading="isBuyerLoading"
                        :search-input.sync="buyerSearch"
                        hide-no-data
                        item-text="name"
                        item-value="id"
                        @change="filterChange"
                        cache-items
                        color="orange lighten-2"
                        max-width="300"
                    ></v-autocomplete>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="text-left text-sm-right">
                <v-menu bottom :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            width="150"
                            depressed
                            class="caption px-10 mt-8 ml-md-4 main--yellow test-white"
                            dark
                            v-on="on"
                        >
                            {{$t('filters')}}
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="filter in layout" :key="filter.systemName"
                            v-if="filter.type === 'switch'"
                        >
                            <v-list-item-action>
                                <v-checkbox
                                    color="orange lighten-2"
                                    class="justify-start justify-sm-center"
                                    :label="filter.label"
                                    v-model="activeFilters[filter.systemName]"
                                    @change="filterChange"
                                ></v-checkbox>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import FiltersGeneral from '../../../app-front/mixins/FiltersGeneral';
    import FilterService from '../../services/api/FilterService';

    export default {
        name: "ProfileSalesFilters",
        mixins:[FiltersGeneral],
        data(){
            return {
                activeFilters: {},
                buyersEntries:[],
                isBuyerLoading: false,
                layout:[],
                buyerSearch: null,
            }
        },
        computed: {
            buyers() {
                return this.buyersEntries.map(entry => {
                    const name = entry.name;
                    return Object.assign({}, entry, { name })
                })
            }
        },
        methods: {
            filterChange(){
                this.addFiltersToUrl(this.activeFilters, this.$route);
                this.$emit('filter-change', this.activeFilters);
            },
            getLayout(){
                FilterService.setLocale(this.$store.state.language.appLanguage);
                FilterService.getProfileSalesLayout()
                    .then(res => {
                        this.layout = res.data;
                    })
                    .then(() => {
                        this.setFiltersFromUrl();
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            setFiltersFromUrl(){
                const filters = this.getFiltersFromUrl();
                const activeFilters = {};
                activeFilters[this.filtersGeneral.archive.systemName] = null;
                activeFilters[this.filtersGeneral.buyer.systemName] = null;
                activeFilters[this.filtersGeneral.consideration.systemName] = null;
                activeFilters[this.filtersGeneral.delivery.systemName] = null;
                activeFilters[this.filtersGeneral.inProcess.systemName] = null;

                window._.forEach(filters, (value, filter) => {
                    switch(filter) {
                        case this.filtersGeneral.archive.systemName:
                            value = this.stringToBoolean(value);
                            activeFilters[this.filtersGeneral.archive.systemName] = value;
                            break;
                        case this.filtersGeneral.consideration.systemName:
                            value = this.stringToBoolean(value);
                            activeFilters[this.filtersGeneral.consideration.systemName] = value;
                            break;
                        case this.filtersGeneral.delivery.systemName:
                            value = this.stringToBoolean(value);
                            activeFilters[this.filtersGeneral.delivery.systemName] = value;
                            break;
                        case this.filtersGeneral.inProcess.systemName:
                            value = this.stringToBoolean(value);
                            activeFilters[this.filtersGeneral.inProcess.systemName] = value;
                            break;
                        case this.filtersGeneral.buyer.systemName:
                            value = this.stringToNumber(value);
                            activeFilters[this.filtersGeneral.buyer.systemName] = value;
                            break;
                    }
                });

                this.activeFilters = activeFilters;
                this.filterChange();
            }
        },
        watch:{
            buyerSearch(val) {
                if(!val || val.length < 3) return;

                if(this.activeFilters.buyer && val === this.activeFilters.buyer.name) return;

                if (this.isBuyerLoading) return;

                this.isBuyerLoading = true;

                FilterService.setLocale(this.$store.state.language.appLanguage);

                FilterService.searchBuyer(val)
                    .then(res => {
                        this.buyersEntries = res.data;
                        this.isBuyerLoading = false;
                    })
                    .catch(err => {console.log(err);});
            },
        },
        created() {
            this.getLayout();
        },
    }
</script>

<style scoped>

</style>
